import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { PlantingSiteDetailDto } from '../../../models/trofaco/plantingSiteDetailDto';
import { Observable } from 'rxjs';
import { PlantingSiteService } from '../../core/services/planting-site.service';
import { NullDataHandlerService } from '../../core/services/null-data-handler.service';

@Injectable({
    providedIn: 'root'
})
export class PlantingSiteDetailsResolverService extends NullDataHandlerService implements Resolve<PlantingSiteDetailDto>  {

    constructor(private plantingSiteService: PlantingSiteService, public router: Router) {
        super(router);
    }

    resolve(route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<PlantingSiteDetailDto> | Promise<PlantingSiteDetailDto> | PlantingSiteDetailDto {
        let id = route.paramMap.get('siteId') || '';
        if (id == 'new') return {
            id: '',
            certificates: [],
            partners: [],
            areas: [],
            collections: [],
            species: [],
            pdfUrl: null
        };

        return this.plantingSiteService.getById(id).then((response) => {
            if (!response) 
                this.redirectToNotFound();
            else
                return response;
        });
    }
}